import { Text } from 'components/common'
import ButtonTagStyle from './style'

const ButtonTag = (props) => {
    return (
        <ButtonTagStyle
            onClick={props.onClick}
            bgColor={props.bgColor}
            className={`flexBoxColumn ${props.parentClass ? props.parentClass : ''} ${props.bordered ? 'bordered' : ''} ${props.purple ? 'purple' : ''}`}>
            <Text
                tag={'h6'}
                className={`PopReg ${props.cssClass ? props.cssClass : ''}`}
                text={props.content}
            />
        </ButtonTagStyle>
    )
}

export default ButtonTag
